import { Container, Spacer, YStack } from '@my/ui'
import { SidebarLayoutProps } from './sidebar-layout-props'
import { NAV_HEIGHT_SM } from '../navigation'

export const SidebarLayout = ({
  children,
  SidebarContent,
  containerProps,
  sidebarContainerProps,
  ...props
}: SidebarLayoutProps) => {
  return (
    <Container ai="flex-start" flex={1} fd="row" pt="$3.5" spaceBottom size="xl" {...props}>
      {/* Side Menu */}
      <YStack
        className="overflow-y-auto"
        pos={'sticky' as 'absolute'}
        alignSelf="flex-start"
        top={NAV_HEIGHT_SM + 16}
        w="100%"
        maxWidth={380}
        minWidth={340}
        pl="$3.5"
        pb="$2"
        display="none"
        $gtMd={{
          display: 'flex',
        }}
        {...sidebarContainerProps}
      >
        {SidebarContent}
      </YStack>

      {/* Main content */}
      <Container
        key="main-container"
        size="sm"
        flexShrink={1}
        flexGrow={1}
        flexBasis={600}
        gap="$3.5"
        gutter
        {...containerProps}
      >
        {children}
      </Container>

      <Spacer
        flex={1}
        flexShrink={9999}
        maxWidth={380}
        minWidth={0}
        flexBasis={340}
        display="none"
        $gtMd={{
          display: 'flex',
        }}
      />
    </Container>
  )
}
